import { useContext, useState } from "react";
import NetworkError from "../../components/NetworkError";
import { config } from "../../constants/config";
import { useEffect } from "react";
import Preloader from "../../components/Preloader";
import { useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import Operation from "../../components/operations/operation";
import Search from "../../components/Search";
import PaginationSelect from "../../components/sPaginationSelect";



export default function Activities() {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [activitylist, setActivitylist] = useState([]);

    const [isSearch, setIsSearch] = useState(false);
    const [chaine, setChaine] = useState('');
    const [nbpage, setNbpage] = useState(1);
    const [page, setPage] = useState(0);
    const [currentpage, setCurrentpage] = useState('');


    const getActivities = async (p) => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/snitchs?limit=${config.secure.limit}&page=${p + 1}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;
                        setNbpage(data?.body?.pages);

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            if (element.ident !== "profilsuperadmin") {
                                clientarraydata.push({ ...element });
                            }
                        });

                        // console.log("liste in data", clientarray)
                        setActivitylist(clientarray);
                        if (user?.isFullAction) {
                            setActivitylist(clientarray);
                        } else {
                            setActivitylist(clientarraydata);
                        }
                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    }

    const autoSearchActivities = async (c) => {

        if ((c && !isSearch) || (c && isSearch)) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
            myHeaders.append("token", config.secure.PUBLICKEY);
            myHeaders.append("apikey", user.token);
            myHeaders.append("cpte", user.code);
            myHeaders.append("prof", user.profil);
            myHeaders.append("conn", user.espace);

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                // body: urlencoded,
                redirect: 'follow'
            };

            // console.log("data send", urlencoded)

            await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/snitchs?crit=${c}`, requestOptions).then((response) => {
                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        // console.log("resonse jsondecode", data);
                        if (data?.head) {
                            let clientarray = [];

                            clientarray = data?.body?.data;
                            setNbpage(data?.body?.pages);

                            let clientarraydata = [];
                            await clientarray.forEach(element => {
                                if (element.ident !== "profilsuperadmin") {
                                    clientarraydata.push({ ...element });
                                }
                            });

                            // console.log("liste in data", clientarray)
                            if (user?.isFullAction) {
                                setActivitylist(clientarray);
                            } else {
                                setActivitylist(clientarraydata);
                            }

                        } else {
                            if (data?.body?.data?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                setError(true);
                            }
                            // setLoading(false);
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    setError(true);
                    // setLoading(false);
                }

            }).catch((err) => {
                // console.log("error", err);
                setError(true);
                // setLoading(false);
            });
        } else if (c !== "" && isSearch) {
            setIsSearch(false);
            getActivities(page);
        } else {
            setIsSearch(false);
            getActivities(page);
        }
    }


    // comportements
    useEffect(() => {
        getActivities(page);
    }, []);

    useEffect(() => {
        const stimeout = setTimeout(() => {
            autoSearchActivities(chaine);
        }, 1000);

        return () => clearTimeout(stimeout);
    }, [chaine]);



    // affichages
    return (
        <>
            {loading && <Preloader />}
            {!loading && error && <NetworkError />}
            {!loading && !error && <div className="container-fluid">
                <h1 className="h4 mb-4 font-weight-bold text_primary">Activities</h1>
                <div className="row">
                    <div className="col-md-2 mb-3">
                        <PaginationSelect nbpage={nbpage} getList={getActivities} page={page} setPage={setPage} current={currentpage} setCurrent={setCurrentpage} />
                    </div>
                    <div className="col-md-10 mb-3">
                        <Search
                            chaine={chaine}
                            setChaine={setChaine}
                            // search={searchEmployee}
                            placeholder="Search an activity..."
                        />
                    </div>
                    <div className="col-md-12">
                        <div className="card shadow mb-4">
                            <div className="card-header py-3">
                                {/* <Link to="/new-licence" data-toggle="tooltip" title="Nouvelle licence" data-placement="left" className="btn-shadow ml-3 btn btn-primary btn-sm float-right">
                                                <i className="fa fa-plus mr-1"></i> <span>Nouvelle licence</span>
                                            </Link> */}
                                <h6 className="m-0 ">List of user's activities</h6>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive mb-3">
                                    <table className="mb-0 table table-bordered">
                                        <thead className="bg-primary">
                                            <tr className="bg-primary text-white">
                                                <th className="text-center">#</th>
                                                <th>User</th>
                                                <th>Account</th>
                                                <th>Object</th>
                                                <th>Action</th>
                                                <th>Date</th>
                                                <th className="text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(activitylist.length === 0) && <tr style={{ borderStyle: "none" }}>
                                                <th colSpan={7} className="text-center">No activity found</th>
                                            </tr>}
                                            {
                                                (activitylist.length > 0) && activitylist?.map((item, index) => (
                                                    <Operation operation={item} position={(config.secure.limit * page) + index} key={index} />
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )

}